import React, { Component, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'

// import LedgerClient from '../../utils/integrations/ledgerClient'
import { Consumer as BNCClientConsumer } from '../context/BNCClientProvider'
import Modal from '../../components/common/Modal'
import signPopupImg from '../../static/images/ledger/sign-popup-img.svg'
import lockImg from '../../static/images/lock.svg'
import zIndex from '../../utils/zIndexScale'
import { NETWORK_ENV } from '../../utils/httpRequest'
import isElectron from '../../utils/isElectron'

import {
  initLedger,
  getApp,
  closeTransport,
  showAddress,
  getVersion,
  getPublicKey,
  sign,
} from '../../utils/ledgerHelper'

const ADDRESS_PREFIX = NETWORK_ENV === 'testnet' ? 'tbnb' : 'bnb'

const Wrapper = styled.div`
  position: relative;
  z-index: ${zIndex.modal};
`

const ModalHeading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    margin-left: 5px;
  }
`

const ModalBody = styled.div`
  color: inherit;
  text-align: center;
`

const ConfirmContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 100px;
    margin-bottom: 20px;
  }
`

const LedgerDelegateConfigurator = ({ bncClient, app, preSignCb, postSignCb }) => {
  // similar to componentDidMount and componentDidUpdate:
  useEffect(() => {
    if (!bncClient || !app) return

    // TODO: temporary Ledger hd path hack until it is in redux
    let tempHdPath = [44, 714, 0, 0, 0]
    const lsHdPath = window.localStorage.getItem('bnc.ledger.hdpath')
    if (lsHdPath) tempHdPath = JSON.parse(lsHdPath)
    if (isElectron()) {
      // eslint-disable-next-line no-return-await
      app.getPublicKey = async hdPath => await getPublicKey(hdPath)

      // eslint-disable-next-line no-return-await
      app.sign = async (signBytes, hdPath) => await sign(signBytes, hdPath)
    }

    bncClient.useLedgerSigningDelegate(app, preSignCb, postSignCb, postSignCb, tempHdPath)
  })
  return null
}

LedgerDelegateConfigurator.propTypes = {
  bncClient: PropTypes.object.isRequired,
  app: PropTypes.object.isRequired,
  ledgerClient: PropTypes.object,
  preSignCb: PropTypes.func,
  postSignCb: PropTypes.func,
}

LedgerDelegateConfigurator.defaultProps = {
  preSignCb: () => {},
  postSignCb: () => {},
  ledgerClient: null,
}

class LedgerModalHost extends Component {
  static propTypes = {
    showConfirmAddress: PropTypes.bool,
    address: PropTypes.string.isRequired,
    isLedger: PropTypes.bool,
    isHardwareBle: PropTypes.bool,
  }

  static defaultProps = {
    showConfirmAddress: false,
    isLedger: false,
    isHardwareBle: false,
  }

  state = {
    client: null,
    error: null,
    showModal: false,
    showAddressConfirmed: false,
    version: {},
  }

  async componentWillMount() {
    const { isLedger } = this.props
    const { client, error } = this.state
    if (!isLedger) return
    if (!client && !error) await this._initLedger()
  }

  async componentWillUpdate(nextProps, nextState) {
    const { isLedger, showConfirmAddress } = nextProps
    const { client, error, showAddressConfirmed } = nextState
    if (!isLedger) return
    if (!client && !this._client && !error) await this._initLedger()

    if (!client) return // no client yet

    // app v1.0 does not support showing the address
    const version = await getVersion()
    if (version.major === 1 && version.minor === 0) return

    // trigger ledger address display - shown before?
    if (this._shownConfirmAddress) return

    // TODO: temporary Ledger hd path hack until it is in redux
    if (showConfirmAddress && !showAddressConfirmed) {
      let tempHdPath = [44, 714, 0, 0, 0]
      const lsHdPath = window.localStorage.getItem('bnc.ledger.hdpath')
      if (lsHdPath) tempHdPath = JSON.parse(lsHdPath)

      // TODO: change me for mainnet
      this._shownConfirmAddress = true
      setTimeout(async () => {
        await showAddress(
          ADDRESS_PREFIX,
          tempHdPath,
          this._setAddressConfirmed,
          this._showAddressPanic
        )
      }, 500)
    }
  }

  componentDidUpdate() {
    const { error } = this.state
    if (!error) return
    console.warn('LedgerModalHost - Ledger error!', error)
  }

  async componentWillUnmount() {
    const { client } = this.state
    if (!client) return
    if (!client && !isElectron()) return
    // close client connection
    await closeTransport()
    // client.getApp()._transport.close()
  }

  _initLedger = async () => {
    const { isHardwareBle } = this.props
    try {
      this._client = await initLedger(isHardwareBle)
      if (this._client.error) throw new Error(this._client.error)
      const version = await getVersion()
      this.setState({ client: this._client, app: getApp(), version })
    } catch (error) {
      this.setState({ error })
    }
  }

  _shouldShowAddressConfirm = () => {
    const { isLedger, showConfirmAddress } = this.props
    const { client, showAddressConfirmed, version } = this.state
    if (!client) return false
    const supportsShowAddress = !(version.major === 1 && version.minor === 0)
    return isLedger && supportsShowAddress && showConfirmAddress && !showAddressConfirmed
  }

  _showSignModal = () => {
    this.setState({ showModal: true })
  }

  _hideSignModal = () => {
    this.setState({ showModal: false })
  }

  _clearError = () => {
    this.setState({ error: null })
  }

  _setAddressConfirmed = () => {
    setTimeout(() => {
      this.setState({ showAddressConfirmed: true, error: null })
    }, 1000)
  }

  _showAddressPanic = err => {
    console.warn('LedgerModalHost _showAddressPanic', err)
    alert('get address failed, please replugin your ledger device')
    // this.setState({ showAddressConfirmed: true, error: null })
    // window.location.href = '/'
  }

  render() {
    const { address, showConfirmAddress } = this.props
    const { error, showModal, showAddressConfirmed, app } = this.state
    return (
      <Wrapper>
        <BNCClientConsumer>
          {bncClient => (
            <LedgerDelegateConfigurator
              bncClient={bncClient}
              app={app}
              preSignCb={this._showSignModal}
              postSignCb={this._hideSignModal}
            />
          )}
        </BNCClientConsumer>

        {showModal ? (
          <Modal title="Ready to Sign">
            <ModalHeading>
              <img
                src={signPopupImg}
                alt="Please sign the transaction on your Ledger"
                width="60%"
              />
            </ModalHeading>
            <ModalBody>
              <p>Please review the transaction on your Ledger device.</p>
              <p>Once checked, you may sign the transaction.</p>
            </ModalBody>
          </Modal>
        ) : null}

        {this._shouldShowAddressConfirm() ? (
          <Modal title="Confirm Ledger Address">
            <ConfirmContent>
              <img src={lockImg} alt="Confirm Ledger Address" />
              <p>For security, please confirm that your address:</p>
              <br />
              <p>
                <strong style={{ fontFamily: 'monospace' }}>{address}</strong>
              </p>
              <br />
              <p>Is the one shown on your Ledger device screen now.</p>
              <p>Press the right ✓ button on your device to confirm.</p>
              <br />
              <p>Or, if it does not match, close this page and contact support.</p>
            </ConfirmContent>
          </Modal>
        ) : null}

        {error && !(showConfirmAddress && !showAddressConfirmed) ? (
          <Modal close={this._clearError} closeText="Retry" title="Ledger Notice">
            <ModalBody>
              {/* <p>A Ledger error occurred:</p>
              <p><i>{error.message}</i></p> */}
              <p>Please connect Ledger and open Binance Chain.</p>
              <p>You must have the Binance Chain Ready screen open to continue.</p>
              <p style={{ marginTop: '1rem' }}>
                <a href="/unlock">Or, click here to unlock another wallet</a>
              </p>
            </ModalBody>
          </Modal>
        ) : null}
      </Wrapper>
    )
  }
}

const mapStateToProps = ({
  account: {
    address,
    flags: { isLedger, isHardwareBle },
  },
}) => ({
  address,
  isLedger,
  isHardwareBle,
})

export default connect(mapStateToProps)(LedgerModalHost)
